/* eslint-disable no-useless-escape */
/* eslint-disable no-prototype-builtins */
import Global from '@/assets/js/global_tool/Global.js'; /*引入全局边框工具*/
import { GET_DEPT_ROOT, GET_DEPT_TREE, GET_USER_BY_DEPT, GET_PAGE_EMPLOYEE,GET_ROLE_DATA } from '@/api/xtbg_system/api_approverFlow'
import userAPI from '@/api/xtbg_system/api_userManage'
import roleAPI from '@/api/xtbg_system/api_roleManage'  //getRoleLists
import znfzAPI from "@/api/organizeManagement/api_organizationUsre";
import cookie from "js-cookie";
const toHump = name => name.replace( /\_(\w)/g, function ( all, letter ) {
  return letter.toUpperCase()
} )


// 需要自行设置nodeID  重要！！！
/*async function getDepChildNode ( orgId ) {
  const promises = [userAPI.iasorganizationge( { orgId } )]
  let res = []
  // loadUser && promises.push( GET_USER_BY_DEPT( { deptId: orgId } ) )
  try {
    res = await Promise.all( promises )
  } catch ( error ) {/!* this.$message.error('获取子节点数据出错')*!/ }
  const nodes = res.reduce( ( p, c ) => {
    return [...p, ...c.data]
  }, [] )
  return nodes
}*/

// 需要自行设置nodeID  重要！！！
async function getDepChildNode ( orgId ) {
  const promises = [GET_DEPT_TREE( { orgId } )]
  let res = []
  // loadUser && promises.push( GET_USER_BY_DEPT( { deptId: orgId } ) )
  try {
    res = await Promise.all( promises )
  } catch ( error ) {/* this.$message.error('获取子节点数据出错')*/ }
  const nodes = res.reduce( ( p, c ) => {
    return [...p, ...c.data]
  }, [] )
  return nodes
}

// 需要返回一个promise
async function loadDepOrUser ( node, loadDep = true ) {
  // let params=Global.common_store.is_super_admin == true?{appId:''}:{appId:  localStorage.getItem('current_app_id')}
  let nodeData = []
  if ( node.level === 0 ) { // 根目录
    // const test = await getRootDept()  // 获取根节点
    // nodeData = [test]
    const userInfo = Global.common_tool.get_user_info().user
    const {code,msg,data} =await userAPI.iasorganizationge({});//机构数
    nodeData = data.list.filter(item => item.enterpriseNumber === userInfo.enterpriseNumber)
  // } else if ( node.level === 1 ) {
  } else if (node.data.children&&node.data.children.length>0 ) {
    nodeData = [...node.data.children, ...(await userAPI.curOrgUserList({ departmentId: node.data.id })).data.list]
    
    // nodeData = await getDepChildNode( node.data.deptId )  // 获取部门节点
    // let userParams= {
    //   "qhdm": node.data.qhdm,
    //   "departmentNumber": node.key,
    //   "name": "",
    //   "userName": ""
    // }
    // let userData = (await userAPI.curOrgUserList(userParams)).data.list  // 获取部门下人员
    // nodeData = node.data.children // 获取部门节点
    // if(userData.length>0){
    //   nodeData=[...nodeData,...userData];
    // }

  // } else if ( !loadDep && node.level === 2 ) {
  } else if ( !loadDep  ) {
   let userParams= {
      departmentId: node.data.id
    }
      // nodeData = ( await GET_PAGE_EMPLOYEE() ).data  // 获取部门下人员  暂时用假的
      nodeData = (await userAPI.curOrgUserList(userParams)).data.list  // 获取部门下人员

  }
  return nodeData
}


// async function getUserData(val){
//   let nodeData = []
//   nodeData= (await userAPI.curOrgUserList({number:val})).data.list
//   return nodeData
// }


// 获取组织结构根节点
// 需要自行设置nodeID  重要！！！
async function getRootDept () {
  let res = []
  try {
    res = ( await GET_DEPT_ROOT() ).data
  } catch ( err ) { }
  return res
}


// 获取角色数据
// 需要自行设置nodeID  重要！！！
async function getROLE () {
  let resData = []
  try {
    let params = { 
      manageNumber: Global.common_tool.get_user_info().org.manageNumber,
      queryType: 2,
      parentId: -1,
     }
    const { data, msg, code } = await znfzAPI.usermanageQueryGroup(params)
    resData = data.groups.map(item => {
      return {
        ...item.group,
        roleId: item.group.id,
        roleName: item.group.name
      }
    });
  } catch ( err ) { }
  return resData
}

function loadDepData ( node ) {
  return loadDepOrUser( node ) // 返回的promise
}

function loadUserData ( node ) {
  return loadDepOrUser( node, false )  // 返回的promise
}

function loadRoleData () {
  return getROLE()  // 返回的promise
}

const defaultOption = {
  tabName: '部门',  // 选项卡名称
  tabKey: 'dep', //选项卡键值 传入的selected要和键值保持一致 eg: {dep: [], role: []}
  children: 'children', // 子节点标志
  // 生成每个节点的id 保证唯一
  nodeId: function ( data ) {
    // return data.hasOwnProperty( 'userId' ) ? data.userId : data.deptId
    return data.hasOwnProperty( 'userId' ) ? data.userId : data.number
  },
  // 生成节点的名称 可选值 string | function
  label: function ( data, node ) {
    // return data.hasOwnProperty( 'userId' ) ? data.userName : data.deptName
    // return data.hasOwnProperty( 'userId' ) ? data.userName : data.name
    return data.name
  },
  // 判断是否为叶子节点 可选值 string | function
  isLeaf: function ( data, node ) {
    return data.hasOwnProperty( 'userId' ) // 含有empID为人员  且为叶子节点
  },
  // 搜索后的结果如果需要展示一些提示文字 例如搜索人员 提示人员所属部门  可以使用该属性
  // function
  searchResTip: function ( data ) {
    return '部门：' + data.enterpriseDeptName
  },
  // 判断该节点是否可选 例如同时选择部门和部门下的人
  disabled: function ( data, node ) {
    return false
  },
  // 动态请求后台拿到节点数据 返回一个promise
  onload: loadDepData,
  // 搜索节点方法
  onsearch: async function ( searchString, resolve, reject ) {
    debugger
    let params={userName:searchString}
    resolve( (await userAPI.curOrgUserList(params)).data.list )
  }
}

const defaultRoleOption = {
  tabName: '职能分组',  // 选项卡名称
  tabKey: 'role', //选项卡键值 传入的selected要和键值保持一致 eg: {dep: [], role: []}
  children: 'children', // 子节点标志
  // 生成每个节点的id 保证唯一
  nodeId: function ( data ) {
    return data.hasOwnProperty( 'number' ) ? data.number : data.id
  },
  // 生成节点的名称 可选值 string | function
  label: function ( data, node ) {
    return data.hasOwnProperty( 'groupName' ) ? data.groupName : data.name
  },
  // 判断是否为叶子节点 可选值 string | function
  isLeaf: function ( data, node ) {
    return data.hasOwnProperty( 'groupName' ) // 含有empID为人员  且为叶子节点
  },
  // 搜索后的结果如果需要展示一些提示文字 例如搜索人员 提示人员所属部门  可以使用该属性
  searchResTip: function ( data ) {
    // return '部门：' + data.deptId
    return ''
  },
  // 判断该节点是否可选 例如同时选择部门和部门下的人
  disabled: function ( data, node ) {
    return false
  },
  // 动态请求后台拿到节点数据 返回一个promise
  onload: loadRoleData,
  // 搜索节点方法
  onsearch: async function ( searchString, resolve, reject ) {
    const params = { 
      manageNumber: Global.common_tool.get_user_info().org.manageNumber,
      queryType: 2,
      parentId: -1,
      groupName: searchString
     }
    const { data, msg, code } = await znfzAPI.usermanageQueryGroup(params)
    const list = data.groups.map(item => {
      return {
        ...item.group,
        roleId: item.group.id,
        roleName: item.group.name
      }
    })
    resolve(list)
  }
}

export const DEP_CONFIG = Object.assign( {}, defaultOption )
export const ROLE_CONFIG = Object.assign( {}, defaultRoleOption, { tabKey: 'role', tabName: '职能分组',onload: loadRoleData, disabled: () => false  } )
export const USER_CONFIG = Object.assign( {}, defaultOption, { tabKey: 'user', tabName: '指定人员', onload: loadUserData, disabled: ( data, node ) => !data.hasOwnProperty( 'userId' ) } )
const DEP_USER_CONFIG = Object.assign( {}, defaultOption, { tabKey: 'dep&user', tabName: '部门和人员', onload: loadUserData, disabled: () => false } )
const POSITION_CONFIG = Object.assign( {}, defaultOption, { tabKey: 'position', tabName: '岗位' } )
export const CONFIG_LIST = [DEP_CONFIG, ROLE_CONFIG, USER_CONFIG, DEP_USER_CONFIG, POSITION_CONFIG]



// WEBPACK FOOTER //
// ./src/components/approverFlow/FormControls/OrgTransfer/config.js